// extracted by css-extract-rspack-plugin
export default {"Label":"default-group-header-label-module__Label__QM8up","AggregateLabels":"default-group-header-label-module__AggregateLabels__Av1Ww"};